import type { TestType } from '@prisma/client';
import { IconBrowser } from '@tabler/icons-react';

export function IdleView({ testType }: { testType: TestType }) {
  const isMobile = testType === 'MOBILE_APP';
  return (
    <div className="cornerBorder flex h-full w-full flex-col items-center justify-center gap-0 bg-gray-600">
      <IconBrowser
        size={80}
        color="white"
      />
      <span className="text-xl font-bold text-white">{isMobile ? 'Mobile Emulator' : 'Browser'}</span>
      <span className="mx-1 text-wrap text-center text-gray-100">
        {isMobile ?
          <>
            Press preview or record
            <br />
            to start the mobile app
          </>
        : 'Press preview or record to start the browser'}
      </span>
    </div>
  );
}
